import { useMutation, useQuery } from "@tanstack/react-query";
import { backendApi } from "./api.service";
import { PaginationRequest } from "./admin.service";

export const useGetAllDepositBonuses = (request: PaginationRequest) => {
  return useQuery({
    queryKey: ["get-deposit-bonuses"],
    queryFn: async () => {
      const config = { params: request };
      const response = await backendApi.get("/deposit-bonus", config);
      if (response.status !== 200) {
        throw new Error(response.data);
      }

      return response;
    },
  });
};

export const useGetDepositBonusById = (id: string) => {
  return useQuery({
    queryKey: ["get-deposit-bonus", id],
    queryFn: async () => {
      const response = await backendApi.get("/deposit-bonus/" + id);
      if (response.status !== 200) {
        throw new Error(response.data?.message);
      }

      return response.data?.data;
    },
    retry: 0,
    gcTime: 0
  });
};

export interface DepositBonusRequest {
  id?: string;
  name: string;
  code: string;
  startTime: string;
  endTime: string;
  description: string;
  maxBonusAmount: number;
  percentage: number;
  claimLimit: number;
  releaseMultiplier: number;
  categories: string;
  status: string;
  gameIds: string[];
}

export const useCreateDepositBonus = () => {
  return useMutation({
    mutationFn: async (data: DepositBonusRequest) => {
      const response = await backendApi.post("/deposit-bonus", data);
      if (response.status !== 200) {
        throw new Error(response.data);
      }

      return response.data;
    },
  });
};

export const useUpdateDepositBonus = () => {
  return useMutation({
    mutationFn: async (data: DepositBonusRequest) => {
      const response = await backendApi.put(`/deposit-bonus/${data.id}`, data);
      if (response.status !== 200) {
        throw new Error(response.data);
      }

      return response.data;
    },
  });
};

export const useGetBonusClaims = (request: PaginationRequest) => {
  return useQuery({
    queryKey: ["get-bonus-claims"],
    queryFn: async () => {
      const config = { params: request };
      const response = await backendApi.get("/deposit-bonus/claims/", config);
      if (response.status !== 200) {
        throw new Error(response.data);
      }

      return response;
    },
    retry: false,
  });
};
